import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import Card from "../../components/Card";
import PageHeader from "../../components/PageHeader";
import EmptyPropertyCard from "./components/EmptyPropertyCard";
import { getProperties } from "../../services/properties";
import { getIcon } from "../../utils";

function AppPrivateProperties() {
  const [isLoading, setIsLoading] = useState(false);
  const [properties, setProperties] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getProperties().then((data) => {
      setIsLoading(false);
      setProperties(data.reverse());
    });
  }, []);

  return (
    <Layout isLoading={isLoading}>
      <PageHeader title="Properties">
        {properties && !!properties.length && (
          <Button
            component={Link}
            size="small"
            variant="contained"
            to="/add-property"
          >
            Add property
          </Button>
        )}
      </PageHeader>
      <Grid container columnSpacing={{ xs: 0, sm: 2 }}>
        {properties &&
          !!properties.length &&
          properties.map((property, index) => (
            <Grid key={index} item xs={12} sm={6} md={3}>
              <Card
                key={index}
                to={`/property/${property.id}`}
                title={`${property.address.street} ${property.address.city} ${property.address.country} ${property.address.postalCode}`}
                actions={
                  <Grid container>
                    {(property?.publicParkingNearby ||
                      property?.onStreetParking ||
                      property?.onSiteParkingIncluded) &&
                      getIcon("PARKING")}
                    {property?.utilities?.map((utility, index) =>
                      getIcon(utility, index)
                    )}
                    {getIcon(property.additionalPetsInBuilding)}
                  </Grid>
                }
              />
            </Grid>
          ))}
      </Grid>
      {(!properties || !properties.length) && <EmptyPropertyCard />}
    </Layout>
  );
}

export default AppPrivateProperties;
